import Immutable from 'immutable';
import { getFilters, getTabletMobileFilters } from "../config/filters";
import Hit from "../records/Hit";
import { getScreenClass } from "./screenClass";
function resolveFacetValuesAndCount(facets, facetKey) {
  const foundFacent = facets.find(facet => facet.get('name') === facetKey);
  return foundFacent ? foundFacent.get('data') : Immutable.Map();
}
export function resolveFacets({
  facets,
  filters,
  featureFlags
}) {
  const screenClass = getScreenClass(window.innerWidth);
  const showDesktopFilters = screenClass === 'xl';
  const receivedFilters = showDesktopFilters ? getFilters({
    featureFlags
  }) : getTabletMobileFilters({
    featureFlags
  });
  return receivedFilters.filter(f => f.get('facet')).map(f => {
    let facetProducts;
    if (f.get('custom')) {
      facetProducts = f.get('customFilters').map(cfp => Immutable.Map({
        label: cfp.get('label'),
        value: cfp.get('value'),
        count: cfp.get('resolveFacetCount') && cfp.get('resolveFacetCount')(facets, filters)
      })).toList();
    } else {
      facetProducts = resolveFacetValuesAndCount(facets, f.get('algoliaFacetKey')).map((count, facetProductValue) => Immutable.Map({
        label: facetProductValue,
        value: facetProductValue,
        count
      })).toList();
    }
    return Immutable.Map({
      useDropDownComponentForSidebar: f.get('useDropDownComponentForSidebar'),
      key: f.get('key'),
      sidebarLabel: f.get('sidebarLabel') || f.get('label'),
      topBarLabel: f.get('topBarLabel') || f.get('label'),
      type: f.get('type'),
      facetProducts,
      openByDefault: !!f.get('openByDefault'),
      primary: !!f.get('primary')
    });
  }).toList();
}
export function resolveSearchResults({
  hits,
  numberOfHits,
  numberOfPages
}) {
  return Immutable.Map({
    hits: hits.map(h => new Hit(h)),
    numberOfHits,
    numberOfPages
  });
}
export function resolveHits(hits) {
  return Immutable.fromJS(hits).map(h => new Hit(h));
}